import * as signalR from '@microsoft/signalr';
import configurations from "commons/configurations";
import {
  AUTH_NAMESPACE,
  SETAR_NOTIFICACAO,
  LIMPAR_NOTIFICACAO,
  FORCE_LOGOUT,
  TOKEN
} from 'store/modules/auth'

let connection = null;
let store = null;
let isStoppingConnection = false;

export function configurarStore(vuexStore) {
    store = vuexStore;
}

export async function iniciarNotificacoes() {
  if (!store) {
    console.warn('Store ainda não configurado.');
    return;
  }

  const token = store.getters[`${AUTH_NAMESPACE}/${TOKEN}`];
  if (!token) {
    console.warn('Tentativa de iniciar SignalR sem token válido.')
    return;
  }

  if (connection) {
    await pararNotificacoes()
  }

  connection = new signalR.HubConnectionBuilder()
    .withUrl(`${configurations.api.baseUri}/hub/notificacoes`, {
      accessTokenFactory: () => store.getters[`${AUTH_NAMESPACE}/${TOKEN}`],
    })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: retryContext => {
        return Math.min(retryContext.previousRetryCount * 2000, 10000);
      }
    })
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  connection.on('NovasNotificacoes', () => {
    store.dispatch(`${AUTH_NAMESPACE}/${SETAR_NOTIFICACAO}`);
  })
  connection.on('LimparNotificacoes', () => {
    store.dispatch(`${AUTH_NAMESPACE}/${LIMPAR_NOTIFICACAO}`);
  });
  connection.onreconnecting(error => {
    if (error) {
      console.warn('Tentando reconectar SignalR...', error);
    }
  });
  connection.onclose(async (error) => {
    if (isStoppingConnection) {
      isStoppingConnection = false;
      return;
    }

    if (error) {
      console.error('Conexão fechada:', error);
    }
    const token = store?.getters?.[`${AUTH_NAMESPACE}/${TOKEN}`];
    if (token) {
      await store.dispatch(`${AUTH_NAMESPACE}/${FORCE_LOGOUT}`, { reason: 'signalr_desconectado' });
    }
  });

  try {
    await connection.start();
  } catch (error) {
    console.error('Nao foi possivel iniciar SignalR.', error);
    const token = store?.getters?.[`${AUTH_NAMESPACE}/${TOKEN}`];
    if (token) {
      await store.dispatch(`${AUTH_NAMESPACE}/${FORCE_LOGOUT}`, { reason: 'signalr_falha_conexao' });
    }
  }
}

export async function pararNotificacoes() {
  if (connection) {
    try {
      isStoppingConnection = true;
      await connection.stop()
    } catch (err) {
      console.error('Erro ao parar conexão SignalR:', err);
    } finally {
      isStoppingConnection = false;
    }
  }

  connection = null;
}